export enum UserGroupNews {
    TRANSPORT_COMPANY = 'TransportCompany',
    SCHOOL = 'School',
    DRIVER = 'Driver',
    COMPANION = 'Companion',
    CLERK = 'Clerk'
}